<template>
  <div class="page_wrap">
    <div class="page_bg">
      <div class="page_left">
        <div class="page_left_flex">
          <div class="page_left_text">RRONTSEAT</div>
          <div class="page_left_text page_left_color">
            B2B
            <span style="color: #fff;">ECOMMERCE</span>
          </div>
          <div class="page_left_text">PLATFROM</div>
          <div class="page_left_texts">前沿时尚 全球连通 精准赋能品牌发展</div>
          <div class="page_left_textl">了解更多</div>
        </div>
      </div>
      <div class="page_right">
        <img class="page_image" src="../assets/home.png" />
      </div>
    </div>
    <div class="page_seller">
      <!-- 品牌列表 -->
      <div>
      <div class="page_img">
        <img class="page_pinpai" src="../assets/pinpai.png" />
      </div>
      <div>
        <div class="carousel">
          <div class="carousel-images" :style="carouselStyle">
            <div v-for="(image, index) in images" :key="index" class="carousel-image">
              <img
                :class="[(index + 1) % 2 == 0 ? 'page_img_ve' : 'page_img_n']"
                :src="require(`@/assets/${image}`)"
                :alt="'Image ' + (index + 1)"
              />
            </div>
          </div>
        </div>
        <div class="flex_butn">
          <button @click="prevImage" class="carousel-button">
            <i class="el-icon-arrow-left page_ico1"></i>
          </button>
          <button @click="nextImage" style="margin-right: 3rem;" class="carousel-button">
            <i class="el-icon-arrow-right page_ico1"></i>
          </button>
        </div>
      </div>
    </div>
       <!-- 我们的优势 -->
      <div class="page_red">
        <div class="page_img" style="margin-top: 6.875rem;">
        <img class="page_pinpai" src="../assets/youshi.png" />
      </div>
        <div v-for="(advantage, index) in advantages" :key="index" :class="[advantage.isVisible ? 'advantage' : '']">
        <div class="page_devs">
          <div class="page_title">{{ advantage.title }}</div>
          <button class="advantage-button" @click="toggleAdvantage(index)"> 
            <i v-if="advantage.isVisible" class="el-icon-arrow-up page_ico2"></i> 
            <i v-if="!advantage.isVisible" class="el-icon-arrow-down page_ico2"></i>
        </button>
        </div>
        <div :class="['advantage-content', { visible: advantage.isVisible }]">
          <div class="page_advantage_d">
            <img class="page_advantage_img" src="../assets/pinpai1.png" />
            <div class="page_set_de_e">
              <div class="page_set_text page_set_text2">{{ advantage.description }}</div>
              <div class="page_set_text">{{ advantage.text }}</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="page_title_text">前沿时尚 全球连通 精准赋能品牌发展</div>
    <div class="page_b2b">
       <div class="page_b2b_flex">
        <div class="page_b2b_b">
          <div class="page_b2b_title">B2BXXXXXXX</div>
          <div class="page_b2b_text">为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮</div>
        </div> 
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai1.png" />
        </div>
       </div>
       <div class="page_b2b_flex">
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai1.png" />
        </div>
        <div class="page_b2b_b">
          <div class="page_b2b_title">B2BXXXXXXX</div>
          <div class="page_b2b_text">为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮</div>
        </div> 
       </div>
       <div class="page_b2b_flex">
        <div class="page_b2b_b">
          <div class="page_b2b_title">B2BXXXXXXX</div>
          <div class="page_b2b_text">为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮</div>
        </div> 
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai1.png" />
        </div>
       </div>
       <div class="page_b2b_flex2">
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai1.png" />
        </div>
        <div class="page_b2b_b">
          <div class="page_b2b_title">B2BXXXXXXX</div>
          <div class="page_b2b_text">为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮为世界前沿品牌和零售制造铸造商业化浪潮</div>
        </div> 
       </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      advantages: [
        {
          title: "优势一",
          description: "为世界前沿品牌和零售制造铸造商业化浪潮",
          isVisible: false,
          text:"为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份"
        },
        {
          title: "优势二",
          description: "描述优势二的标题",
          isVisible: false,
          text:"描述优势二的具体内容"
        },
        {
          title: "优势三",
          description: "描述优势三的标题",
          isVisible: false,
          text:"描述优势三的具体内容"
        },
        {
          title: "优势四",
          description: "描述优势二的标题",
          isVisible: false,
          text:"描述优势四的具体内容"
        },
        {
          title: "优势五",
          description: "描述优势二的标题",
          isVisible: false,
          text:"描述优势五的具体内容"
        },
      ],
      currentIndex: 0,
      images: [
        "pinpai1.png",
        "pinpai2.png",
        "pinpai3.png",
        "pinpai4.png",
        "pinpai1.png",
        "pinpai2.png",
        "pinpai3.png",
        "pinpai4.png"
      ],
      transitionDuration: 500 // 毫秒
    };
  },
  computed: {
    carouselStyle() {
      const translateX = -this.currentIndex * 24 + "%"; // 假设每个图片宽度为100%
      return {
        transition: `transform ${this.transitionDuration}ms ease`,
        transform: `translateX(${translateX})`
      };
    }
  },
  methods: {
    toggleAdvantage(index) {
      this.$set(this.advantages, index, {
        ...this.advantages[index],
        isVisible: !this.advantages[index].isVisible
      });
    },
    nextImage() {
      if (this.currentIndex == this.images.length - 3) {
        return false
      }
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevImage() {
      if (this.currentIndex == 0) {
        return false
      }
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;

    }
  }
};
</script>

<style scoped>
.page_wrap {
  /* padding-top: 5rem; */
}

.page_bg {
  width: 100%;
  height: 49.3rem;
  background-color: #131316;
  display: flex;
}

.page_left {
  width: 50%;
  position: relative;
}

.page_left_flex {
  z-index: 100;
  position: absolute;
  right: -11%;
  top: 30%;
  color: #fff;
}

.page_left_text {
  font-size: 3.75rem;
  line-height: 4.75rem;
}

.page_left_texts {
  line-height: 2rem;
  margin-bottom: 1.9rem;
  font-size: 1.5rem;
  color: #dedee3;
}

.page_left_textl {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  height: 2.875rem;
  background: #fff;
  color: #131316;
}

.page_left_color {
  color: #e2bf6b;
}

.page_right {
  height: 50%;
}

.page_image {
  width: 36.3rem;
  height: 49.3rem;
}

.page_seller {
  background: #fff;
  padding: 6.875rem 0 6.875rem 5rem;
}

.page_img {
  margin-bottom: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_pinpai {
  width: 22.8rem;
  height: 7.5rem;
}

.carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-images {
  display: flex;
  align-items: center;
  transition: transform 0.5s ease;
}

.carousel-image {
  /* min-width: 100%; */
  box-sizing: border-box;
}

.carousel-image .page_img_ve {
  /* width: 100%; */
  width: 20rem;
  height: 21.875rem;
  object-fit: cover; 
  display: block;
  margin-right: 2rem;
}

.carousel-image .page_img_n {
  /* width: 100%; */
  width: 20rem;
  height: 20rem;
  object-fit: cover; 
  display: block;
  margin-right: 2rem;
}

.carousel-button {
  width: 2.25rem;
  height: 2.25rem;
  background: #000;
  border: none;
  border-radius: 50%;
  margin-left: 1.4rem;
  margin-top: 5.1rem;
}

.page_ico1 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
}

.flex_butn {
  width: 100%;
  text-align: right;
}





/* 我们的优势 */
.advantage {
  /* margin-bottom: 20px; */
  /* padding-bottom: 3.25rem; */
}

.advantage-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.advantage-content.visible {
  max-height: 40rem;
  /* 可以根据需要调整这个值 */
}

button {
  margin-top: 5px;
  cursor: pointer;
}

.page_devs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.1rem solid #D8D8D8;
  margin-bottom: 3.25rem;
}

.page_red {
  padding-right: 5rem;
}

.advantage-button {
  width: 1.875rem;
  height: 1.875rem;
  background: #000;
  border: none;
  border-radius: 50%;
}

.page_ico2 {
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
}

.page_title {
  color: #222;
  font-size: 2.25rem;
  line-height: 3.125rem;
}

.page_advantage_d {
 display: flex;
}
.page_set_de_e{
  width: 60%;
  margin-left: 2.875rem;
}

.page_advantage_img {
  width: 27.5rem;
  height: 20.5rem;
  object-fit: cover; 
  z-index: 100;
  margin-bottom: 2rem;
}

.page_set_text{
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #222222;
}
.page_set_text2{
  padding: 1.75rem 0;
}
/*  */

.page_title_text{
  width: 100%;
  height: 20.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #131316;
  font-size: 3.625rem;
}
.page_b2b{
  padding: 6.875rem 5rem;
  
}
.page_b2b_flex{
  margin-bottom: 5rem;
  display: flex;
  justify-content: space-between;
}
.page_b2b_flex2{
  display: flex;
  justify-content: space-between;
}
.page_b2b_b{
  width: 50%;
}
.page_b2b_c{
  width: 40%;
}
.page_b2b_c_img{
  width: 33.75rem;
  height: 41.87rem;
  object-fit: cover;
}
.page_b2b_title{
  color: #222222;
  font-size: 4.5rem;
  line-height: 5rem;
  margin-bottom: 5rem;
  margin-top: 5rem;
}
.page_b2b_text{
  color: #222222;
  font-size: 1.625rem;
  line-height: 3rem;
}
</style>
